<template>
  <v-container fluid>
    <PageTitle>
      Create New Team
    </PageTitle>

    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card class="mb-4">
        <v-card-text class="pb-0">

          <v-text-field v-model="form.name"
                        label="Team Name"
                        outlined
                        dense
                        :error-messages="form.errors.get('name')">
          </v-text-field>

          <v-text-field v-model="form.email"
                        type="email"
                        label="Owner Email"
                        outlined
                        dense
                        :error-messages="form.errors.get('email')"
                        hint="Must be an existing Mobile Locker user"
                        persistent-hint
                        class="mb-4">
          </v-text-field>

          <v-text-field v-model="form.license_end_date"
                        type="date"
                        label="License End Date"
                        outlined
                        dense
                        :error-messages="form.errors.get('license_end_date')">
          </v-text-field>

          <v-select v-model="form.team_type"
                    label="Team Type"
                    :items="teamTypes"
                    item-value="id"
                    item-text="name"
                    outlined
                    dense
                    :error-messages="form.errors.get('team_type')">
          </v-select>

        </v-card-text>
        <v-card-actions class="px-4">

          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Create Team
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import moment from 'moment-timezone';
import PageTitle from '../../components/PageTitle.vue';
import {mapGetters} from 'vuex';
import teamService from '../../../../ml/services/teamService';

export default {
  components: {PageTitle},
  data() {
    return {
      form: new Form({
        name: '',
        email: '',
        license_end_date: moment().add(1, 'year').format('YYYY-MM-DD'),
        plan: 'enablement_300', // MLD-1641
        team_type: 'Customer',
      }),
      teamTypes: teamService.getTeamTypes(),
    }
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
  },
  created() {
    this.form.email = this.user.email;
  },
  methods: {
    submit() {
      if (this.form.busy) {
        return;
      }
      this.form.post(`/api/teams`)
        .then(response => {
          location.assign(`/admin/teams`);
        })
        .catch(err => {

        })
    }
  }
}
</script>
